import { render, staticRenderFns } from "./ReportQuery.vue?vue&type=template&id=ca2dd496"
import script from "./ReportQuery.vue?vue&type=script&lang=js"
export * from "./ReportQuery.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports